import { render, staticRenderFns } from "./ChartHint.vue?vue&type=template&id=ba7815b6&scoped=true&"
import script from "./ChartHint.vue?vue&type=script&lang=js&"
export * from "./ChartHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7815b6",
  null
  
)

export default component.exports